<template>
  <div>
    <el-select v-model="text"
      :loading="loading"
      :style="cusStyle"
      :size="size"
      :loading-text="$lang('查询中...')"
      :multiple="multiple"
      :filterable="remote?true:filterable"
      :remote="remote"
      :readonly="readonly"
      :remote-method="handleRemoteMethod"
      :collapse-tags="tags"
      :clearable="disabled?false:clearable"
      :placeholder="placeholder"
      reserve-keyword
      default-first-option
      :multiple-limit="limit"
      :value-key="valueKey || 'id'"
      :disabled="disabled"
      @compositionupdate.native="handleComposition"
      @compositionstart.native="handleComposition"
      @compositionend.native="handleComposition">
      <el-option :label="$lang('全部')" :value="''" v-if="hasAll && !remote"></el-option>
      <template v-if="groupChildren">
        <el-option-group v-for="group in netDic"
                         :key="getLabelText(group)"
                         :label="getLabelText(group)">
          <el-option v-for="(item,index) in group[groupChildren]"
                     :key="index"
                     :disabled="item[disabledKey]"
                     :label="$lang(getLabelText(item))"
                     :value="props.valueObj ? item : item[valueKey]">
          <slot :name="prop+'Type'"
                :label="$lang(labelKey)"
                :value="valueKey"
                :item="item"></slot>
          </el-option>
        </el-option-group>
      </template>
      <template v-else>
        <el-option v-for="(item,index) in netDic"
                  :key="index"
                  :disabled="item[disabledKey]"
                  :label="$lang(getLabelText(item))"
                  :value="props.valueObj ? item : item[valueKey]">
          <slot :name="prop+'Type'"
                 :label="$lang(labelKey)"
                :value="valueKey"
                :item="item"></slot>
        </el-option>
      </template>
      <template slot="prefix" v-if="remote">
        <i class="el-icon-search" style="width:22px"></i>
      </template>
    </el-select>
  </div>
</template>

<script>
import props from './props.js'
import { mapGetters } from 'vuex'
import forEach from 'lodash/forEach'
import find from 'lodash/find'
import fetch from '@http/request'
// import { BASE_URL } from '@constants'
import { RESPONSE_SUCCESS } from '@constants'
import qs from 'qs'
export default {
  name: 'BaseSelect',
  mixins: [props()],
  data() {
    return {
      loading: false,
      isOnComposition: false,
      previousQuery: null,
      netDic: [],
    }
  },
  props: {
    value: [Object, Array, Number, String],
    //  下拉分组数据子集的key，分组时必传
    groupChildren: {
      type: String,
      default: '',
    },
    cusStyle: {
      type: Object,
      default: () => { },
    },
    remote: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 99,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      lang: 'lang',
    }),
    valueKey() {
      return this.props.value
    },
  },
  watch: {
    dic: {
      handler(val) {
        this.netDic = val
      },
      immediate: true,
    },
    text: {
      handler(val) {
        //  为0表示全部
        // if (this.text === 0) {
        //   this.text = null
        // }
        // 加入默认数据
        forEach(this.selectDic, (opt) => {
          if (!this.inNetDic(opt)) {
            this.netDic.push(opt)
          }
        })
        // this.handleChange(val);
        this.$emit('input', val)
        this.$emit('change', val)
      },
      immediate: true,
    },
    selectDic: {
      immediate: true, // immediate选项可以开启首次赋值监听
      handler(arr) {
        forEach(arr, (opt) => {
          if (!this.inNetDic(opt)) {
            this.netDic.push(opt)
          }
        })
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    // console.log(this.dicUrl)
    if (this.dicUrl && !this.remote) {
      this.getUrlDic(this.dicQuery)
    }
  },
  methods: {
    isKorean(text) {
      const reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi
      return reg.test(text)
    },
    // 自定义选项文字
    getLabelText(item) {
      if (typeof this.tpyeformat === 'function') {
        return this.tpyeformat(item, this.labelKey, this.valueKey)
      }
      return item[this.labelKey]
    },
    handleComposition(event) {
      if (this.multiple) return
      const text = event.target.value
      if (event.type === 'compositionend') {
        this.isOnComposition = false
        this.$nextTick(_ => this.handleRemoteMethod(text))
      } else {
        const lastCharacter = text[text.length - 1] || ''
        this.isOnComposition = !this.isKorean(lastCharacter)
      }
    },
    handleRemoteMethod(query) {
      if (this.previousQuery === query || this.isOnComposition) return
      this.previousQuery = query
      if (!query) {
        this.netDic = []
        return
      }
      this.dicQuery[this.props.keyword] = query
      this.getUrlDic(this.dicQuery)
    },
    inNetDic(item) {
      if (!item[this.valueKey]) return true
      return !!find(this.netDic, (o) => o[this.valueKey] === item[this.valueKey])
    },
    clearDic() {
      this.netDic = []
      this.previousQuery = null
    },
    getUrlDic(params) {
      this.loading = true
      fetch.get(this.dicUrl + '?' + qs.stringify(this.dicQuery)).then(res => {
        if (res.code === RESPONSE_SUCCESS) {
          if (this.resKey) {
            this.netDic = res.data[this.resKey]
          } else {
            this.netDic = res.data
          }
        }
        this.loading = false
      })
    },
  },
}
</script>
